module.exports = __webpack_public_path__ + "img/Artboard 53.8f092c5f.png";